import { Button } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoiceView } from '../../../../hooks/useTrackInvoiceView'
import { useDuplicateInvoice } from '../../hooks/useDuplicateInvoice'

export const DuplicateInvoiceButton = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoiceView } = useTrackInvoiceView()
  const { duplicateInvoice } = useDuplicateInvoice()

  const handleDuplicateInvoiceButtonClick = useCallback(() => {
    trackInvoiceView('Duplicate action clicked')
    duplicateInvoice()
  }, [duplicateInvoice, trackInvoiceView])

  return (
    <Button icon="copy" onClick={handleDuplicateInvoiceButtonClick} variant="outlined">
      {t('external_invoices.view.duplicate')}
    </Button>
  )
}
